import type { Subscription } from 'rxjs/Subscription';
import type { StoreActionApi } from '@atlassian/react-sweet-state';
import { NEW_GROUP_ID } from '../../../../common/constants';
import { getTicketTypeIdsByGroupId, getGroupIdsByTicketTypeId } from '../../selectors';
import type { ImmutableState } from '../../types';
import type { ActionCallback } from '../types';
import updateTicketTypesByGroup from '../update-ticket-types-by-group';
import { updateGroupsByTicketTypeMutator } from '../utils';

const addTicketTypeRelation =
	(groupId: number, ticketTypeId: number, callback: ActionCallback<undefined>) =>
	({ getState, setState, dispatch }: StoreActionApi<ImmutableState>): Subscription => {
		const state: ImmutableState = getState();
		const existingTicketTypesByGroup = getTicketTypeIdsByGroupId(state, groupId) || [];
		const existingGroupsByTicketType = getGroupIdsByTicketTypeId(state, ticketTypeId) || [];

		if (NEW_GROUP_ID !== groupId) {
			setState(
				updateGroupsByTicketTypeMutator(
					ticketTypeId,
					[...existingGroupsByTicketType, groupId],
					state,
				),
			);
		}

		return dispatch(
			updateTicketTypesByGroup(
				groupId,
				[...existingTicketTypesByGroup, ticketTypeId],
				state,
				callback,
			),
		);
	};

export default addTicketTypeRelation;
